"use client";
import { makeStyles } from "@fluentui/react-components";
import { Link16Regular } from "@fluentui/react-icons";
import { getDocumentIcon } from "@skanska/vsa-file-icon";
import { useTranslation } from "react-i18next";
import { Tool, ToolTypes } from "../../models/Tool";
import {
  getToolOpenUrl,
  getToolType,
  getToolUrl,
} from "../../services/ToolService";
import { VsaaColorTokens } from "../../style/VsaaColorTokens";
import ToolDownloadButton from "./ToolDownloadButton";

const useStyles = makeStyles({
  toolIcon: {
    width: "20px",
    height: "20px",
    color: VsaaColorTokens.color_text_primary,
  },
  toolLinks: {
    textDecoration: "none",
    color: VsaaColorTokens.color_hyperlink,
    fontSize: "15px",
    fontFamily: "Shape Sans Light !important",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    "&:hover": {
      textDecoration: "underline",
    },
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  toolReadOnlyLinks: {
    textDecoration: "none",
    fontSize: "15px",
    fontFamily: "Shape Sans Light !important",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
});

interface IToolLink {
  tool: Tool;
  readonly?: boolean;
  showDownloadButton?: boolean;
  isDraft?: boolean;
}

const ToolLink = (props: IToolLink) => {
  const { tool, readonly, showDownloadButton, isDraft } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  if (readonly && getToolType(tool) === ToolTypes.Document) {
    return (
      <div className={classes.toolReadOnlyLinks}>
        {tool.fileUniqueId ? (
          <div>
            <img
              src={getDocumentIcon(tool.fileType)}
              alt={t("documentLinkIconAltText")}
              className={classes.toolIcon}
            />
          </div>
        ) : (
          <Link16Regular className={classes.toolIcon} />
        )}
        {getToolUrl(tool.webUrl)}
        {showDownloadButton && (
          <ToolDownloadButton tool={tool} isDraft={isDraft} />
        )}
      </div>
    );
  }

  return (
    <a
      href={getToolOpenUrl(tool)}
      target="_blank"
      rel="noreferrer"
      className={classes.toolLinks}
    >
      {tool.fileUniqueId ? (
        <div>
          <img
            src={getDocumentIcon(tool.fileType)}
            alt={t("documentLinkIconAltText")}
            className={classes.toolIcon}
          />
        </div>
      ) : (
        <Link16Regular className={classes.toolIcon} />
      )}
      {getToolUrl(tool.webUrl)}
    </a>
  );
};
export default ToolLink;
